<template>
  <el-form :model="planForm" ref="basic" :rules="basicFormRules" :label-width="formLabelWidth">
    <!-- 批量复制、修改流程的账号选择插槽 -->
    <slot></slot>

    <slot name="projectname">
      <el-form-item label="计划名称" prop="project_name">
        <DynamicWordsInput v-model="planForm.project_name" :words="V3_DYNAMIC_WORDS">
          <el-input
            reference="input"
            style="width: 320px"
            v-model="planForm.project_name"
            placeholder="最大90个字符, 一个中文等于2个字符"
          ></el-input>
        </DynamicWordsInput>
      </el-form-item>
    </slot>

    <el-form-item label="应用平台">
      <el-radio-group
        :disabled="pageStates.isEdit || pageStates.isDuplicate || pageStates.isModify"
        v-model="planForm.ch_platform_id"
        @change="onPlatformChange"
      >
        <el-radio-button v-for="p in PLATFORM_LIST" :key="p.value" ghost :label="p.value">{{ p.label }}</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="投放应用" prop="game_id">
      <el-select
        v-model="planForm.game_id"
        value-key="id"
        @change="onGameSelectChange"
        :disabled="pageStates.isDuplicate || pageStates.isModify"
        style="width: 320px"
        filterable
        clearable
        placeholder="请选择游戏"
      >
        <el-option v-for="item in popularGames" :key="item.id" :label="item.name" :value="item"> </el-option>
      </el-select>
      <p class="ad-package" v-if="planForm.game_id">
        {{ planForm.game_id.ad_package }}
      </p>
    </el-form-item>

    <el-form-item label="回调开关">
      <el-switch
        :disabled="[PLATFORM.IOS, PLATFORM.MINIGAME].includes(planForm.ch_platform_id)"
        v-model="planForm.callback_switch"
      ></el-switch>
      <span style="color: red; font-size: 12px">&emsp;注意：IOS和微信小游戏默认一开启，安卓接了腾讯计划SDK时默认关闭！</span>
    </el-form-item>

    <!-- 只有批量新建流程会显示 -->
    <template v-if="pageStates.isCreate && pageStates.isADA">
      <el-form-item label="自动化任务">
        <AutoTaskModal
          :data="planForm.monitorPlan"
          :media="16"
          :open-id="ch_op_id"
          @on-delete="onMonitorClear"
          @on-select="onMonitorChange"
        />
      </el-form-item>

      <el-form-item
        v-if="planForm.ch_platform_id === PLATFORM.ANDROID"
        label="腾讯分包"
        prop="game_id.gdtAppid"
        :rules="basicFormRules.gdtAppid"
      >
        <!-- 如果选择了投放应用 ，显示对应的分包信息-->
        <div class="package-info" v-if="planForm.game_id.id">
          <div class="info" v-if="planForm.game_id.gdtAppid">
            <p>分包功能正常</p>
            <p>应用账号ID：{{ planForm.game_id.gdtAcid }}</p>
            <p>应用ID：{{ planForm.game_id.gdtAppid }}</p>
          </div>
          <div v-else class="empty">无腾讯分包信息</div>
        </div>
      </el-form-item>
    </template>
  </el-form>
</template>
<script>
import Cookies from 'js-cookie'

import DynamicWordsInput from '@/components/dynamic-words-input'
import AutoTaskModal from '@/components/select/select-monitor.vue'

import { RULES } from '../../model/project-rules.js'
import { PLATFORM, PLATFORM_LIST, PROMOTED_TYPE_LIST, MARKETING_CARRIER_TYPE, V3_DYNAMIC_WORDS } from '../../model/project-const.js'
import { initPageData, POPULAR_GAMES } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([POPULAR_GAMES])
const ch_op_id = Cookies.get('ch_op_id')

export default {
  components: { DynamicWordsInput, AutoTaskModal },
  props: {
    value: {
      type: Object
    },
    formLabelWidth: {
      type: String,
      default: '180px'
    }
  },
  inject: ['projectInstance'],
  data() {
    return {
      V3_DYNAMIC_WORDS,
      PLATFORM_LIST,
      ch_op_id: Number(ch_op_id),
      // basicFormRules
      ...RULES,
      PLATFORM
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    planForm: {
      get() {
        return this.value
      },
      set(form) {
        this.$emit('input', form)
      }
    },
    /**
     * @description: 根据平台筛选常用游戏
     * @return {*}
     */
    popularGames() {
      return this.POPULAR_GAMES.filter((game) => game.ch_platform_id === this.planForm.ch_platform_id)
    },
    pageStates() {
      return this.projectInstance.pageStates
    }
  },
  methods: {
    /**
     * @description: 切换平台
     */
    onPlatformChange(platform) {
      const newForm = { ...this.planForm }
      // 清空投放应用
      newForm.game_id = {}
      if (platform === PLATFORM.IOS || platform === PLATFORM.MINIGAME) {
        newForm.callback_switch = true
      }
      // 重新设置推广推广目的
      const promoted_object_type = [''].concat(PROMOTED_TYPE_LIST)[platform]
      newForm.promoted_object_type = promoted_object_type

      // 切换平台时，清空外部游戏id，需要重新选择
      newForm.promotedObject = {}

      // 腾讯广告3.0，切换平台时，营销对象切换到对应的平台
      if (this.pageStates.isV3) {
        switch (platform) {
          case PLATFORM.ANDROID:
            newForm.marketing_carrier_type = MARKETING_CARRIER_TYPE.APP_ANDROID
            break
          case PLATFORM.MINIGAME:
            newForm.marketing_carrier_type = MARKETING_CARRIER_TYPE.MINI_GAME
            break
          case PLATFORM.IOS:
            newForm.marketing_carrier_type = MARKETING_CARRIER_TYPE.APP_IOS
            break
        }
      }

      this.planForm = newForm
      // 一定要加nextTick，否则this.planForm会有更新错误
      this.$nextTick(() => {
        this.$bus.$emit('platformChange', platform)
      })
    },
    onGameSelectChange({ sdks }) {
      this.projectInstance.doPlanFormClearValidate()
      if (this.planForm.ch_platform_id === PLATFORM.ANDROID) {
        if (Array.isArray(sdks)) {
          // 【API数据回调】对于接了媒体SDK参数的安卓包体，默认回调开关是关闭的；没有对接媒体参数的，默认开启；
          this.planForm.callback_switch = !sdks.includes('2003')
        }
      }
    },
    onMonitorClear(id) {
      const newForm = { ...this.planForm }
      newForm.monitorPlan = newForm.monitorPlan.filter((row) => row.id !== id)
      this.planForm = newForm
    },
    onMonitorChange(items) {
      const newForm = { ...this.planForm }
      newForm.monitorPlan = items.map((row) => ({ id: row.id, name: row.name }))
      this.planForm = newForm
    },
    formValidate() {
      return this.$refs.basic.validate()
    },
    clearValidate() {
      this.$refs.basic.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped></style>
